import { INDODAX_WS_CHANNELS, INDODAX_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const INDODAX_METADATA = {
  id: 'indodax' as ExchangeId,
  restDocs: [
    'https://github.com/btcid/indodax-official-api-docs',
    'https://github.com/btcid/indodax-official-api-docs/blob/master/Public-Rest-API.md',
  ],
  wsDocs: ['https://github.com/btcid/indodax-official-api-docs/blob/master/WebSocket.md'],
  wsTopology: INDODAX_WS_TOPOLOGY,
  wsChannels: INDODAX_WS_CHANNELS,
  notes: [
    'Indonesian cryptocurrency exchange.',
    'Most pairs quoted in IDR (Indonesian Rupiah).',
    'Symbol format: lowercase no separator (btcidr).',
    'Ticker ID format: lowercase with underscore (btc_idr).',
    'Uses TradingView UDF endpoint for kline data.',
    'Timestamps are in seconds (not milliseconds).',
  ],
} as const;
